import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const generateAndSendOpenUserInvitation = ({ onResponse, onError, body }) => {
  fetch(
    "/api/open_user_invitations",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getOpenUserInvitations = ({ onResponse, onError }) => {
  fetch(
    `/api/open_user_invitations`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getUserInvitationRequests = ({ onResponse, onError }) => {
  fetch(
    `/api/user_invitation_requests`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const closeAndResendInvitation = ({ invitation, onResponse, onError, authenticityToken }) => {
  fetch(
    `/api/open_user_invitations/${invitation.id}/close_and_resend`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ authenticity_token: authenticityToken }),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const closeInvitation = ({ invitation, onResponse, onError, body }) => {
  fetch(
    `/api/open_user_invitations/${invitation.id}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const approveUserInvitationRequest = ({ userInvitationRequest, onResponse, onError, body }) => {
  fetch(
    `/api/user_invitation_requests/${userInvitationRequest.id}/approve`,
    {
      method: HTTPRequestMethods.PATCH,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const denyUserInvitationRequest = ({ userInvitationRequest, onResponse, onError, body }) => {
  fetch(
    `/api/user_invitation_requests/${userInvitationRequest.id}/deny`,
    {
      method: HTTPRequestMethods.PATCH,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
